/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function ElectoralFinanaceReportsInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Electoral Finance Reports"
              description={
               <>
               <h4>Political Donations Annual Reports</h4>
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><u><a href="/files/AnnualDonations/2024/PoliticalContributionsRegime_2024.pdf">Political Donations Annual Report 2024</a></u></li> <br />
                    <li><u><a href="/files/ElectoralFinanceReports/2023_Annual_Reports/PoliticalContributionsRegime_2023.pdf">Political Donations Annual Report 2023</a></u></li> <br />
                    <li><u><a href="/files/AnnualDonations/2022/PoliticalContributionsRegime_2022.pdf">Political Donations Annual Report 2022</a></u></li> <br />
                    <li><u><a href="/files/AnnualDonations/2021/PoliticalContributionsRegime2021.pdf">Political Donations Annual Report 2021</a></u></li> <br />
                    <li><u><a href="/files/AnnualDonations/2020/PoliticalContributionsReport2020.pdf">Political Donations Annual Report 2020</a></u></li> <br />
                    <li><u><a href="/files/AnnualDonations/2019/PoliticalContributionsReport2019.pdf">Political Donations Annual Report 2019</a></u></li> <br />
                  </ul>
                  <br />
                  <h4>Registered Party Audited Financial Statements</h4>
                  <br />
                  The Elections Act requires registered political parties in Nova Scotia to submit an independently audited financial statement to Elections Nova Scotia annually by April 30th. Elections Nova Scotia posts these statements here on our website in accordance with legislation each year in early May.
                  <br/>  <br/>
                  <h4>2024</h4>  <br/>
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><u><a href="/files/ElectoralFinanceReports/2024_Annual_Reports/GreenPartyFinancialStatements2024.pdf">Green Party of Nova Scotia</a></u></li><br />
                    <li><u><a href="/files/ElectoralFinanceReports/2024_Annual_Reports/LiberalPartyFinancialStatements2024.pdf">Liberal Association of Nova Scotia</a></u></li><br />
                    <li><u><a href="/files/ElectoralFinanceReports/2024_Annual_Reports/NDP Audited FS 2024 revised Aug 26, 2025.pdf">Nova Scotia New Democratic Party</a></u></li><br />
                    <li><u><a href="/files/ElectoralFinanceReports/2024_Annual_Reports/PCPartyFinancialStatements2024.pdf">The Progressive Conservative Association of Nova Scotia</a></u></li><br />
                  </ul>
                  <br/>
                  <h4>2023</h4>  <br/>
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><u><a href="/files/ElectoralFinanceReports/2023_Annual_Reports/Green Party Financial Statement.pdf">Green Party of Nova Scotia</a></u></li><br />
                    <li><u><a href="/files/ElectoralFinanceReports/2023_Annual_Reports/Liberal Financial Statement 2023_1.pdf">Liberal Association of Nova Scotia</a></u></li><br />
                    <li><u><a href="/files/ElectoralFinanceReports/2023_Annual_Reports/NDP 2023_financial_statements.pdf">Nova Scotia New Democratic Party</a></u></li><br />
                    <li><u><a href="/files/ElectoralFinanceReports/2023_Annual_Reports/NS United 2023FS.pdf">Nova Scotians United</a></u></li><br />
                    <li><u><a href="/files/ElectoralFinanceReports/2023_Annual_Reports/PC Party Financial Statement.pdf">The Progressive Conservative Association of Nova Scotia</a></u></li><br />
                  </ul>
                  <br/>
                  <h4>Registered Political Party Public Funding</h4>
                  <br/>
                  <ul style={{ paddingLeft: "40px" }}>
                    <li><u><a href="/files/ElectoralFinanceReports/Payments to Registered Parties Oct  1 2025.pdf">Payments to Registered Political Parties</a></u></li><br />
                  </ul>
               </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ElectoralFinanaceReportsInformation;
